// tab.service.ts
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

interface Tab {
  title: string;
  route: string;
  id: string; // ID único para associar com a div correspondente
  contentLoaded: boolean; // Flag to check if content is loaded
}

@Injectable({
  providedIn: 'root'
})
export class TabService {
  tabs: Tab[] = [];
  activeTabIndex = 0;

  constructor(private router: Router) { }

  addTab(title: string, route: string) {
    const existingTab = this.tabs.find(tab => tab.route === route);
    
    if (!existingTab) {
      const id = `tab-${this.tabs.length}`;
      this.tabs.push({ title, route, id, contentLoaded: false });
      this.activeTabIndex = this.tabs.length - 1;
    } else {
      this.activeTabIndex = this.tabs.indexOf(existingTab);
    }
  }

  setActiveTab(index: number) {
    this.activeTabIndex = index;
  }

  getActiveTab() {
    return this.activeTabIndex;
  }

  closeTab(index: number) {
    this.tabs.splice(index, 1);
    if (this.activeTabIndex >= this.tabs.length) {
      this.activeTabIndex = this.tabs.length - 1;
    }

    console.log('this.tabs.length', this.tabs);
    if (this.tabs.length === 0) {
      console.log('this.tabService.tabs.length', this.tabs.length);	
      this.router.navigateByUrl('');
    } 
    else 
    {
      console.log('this.activeTabIndex', this.activeTabIndex);
      console.log('this.tabs[this.activeTabIndex].route', this.tabs[this.activeTabIndex].route);
      this.setActiveTab(this.activeTabIndex);
      this.router.navigateByUrl(this.tabs[this.activeTabIndex].route).then(success => {
        if (success) {
          console.log('Navigation successful');
        } else {
          console.error('Navigation failed');
        }
      }).catch(error => {
        console.error('Navigation error:', error);
      });;
    }
  }
  
  closeActiveTab() {
    console.log('Closing tab at index:', this.activeTabIndex);
    this.closeTab(this.activeTabIndex);
  }

  closeAllTabs() {
    this.tabs.length = 0;
    this.activeTabIndex = 0; // Reset active tab index as there are no tabs left
  }
}
